import styled, { css } from 'styled-components';
import palette from '../../../lib/styles/palette';
import React, { useState, useEffect } from 'react';

// import { RowInput, RowOutput, RowSelect } from "./PowerCalculationJIS";
import { useDispatch } from 'react-redux';
import { changeBody } from '../../../modules/conveyor/conveyorWriteSlice';

import { formatDisplayValue } from '../../../lib/styles/perttierNumber';

import { gearCouplingData, selectGearCoupling } from '../../../lib/data/gearCoupling-data';
// import { fluidCouplingData, fluidCouplingSelection } from "../../../lib/data/fluidCoupling-data";
import {
    fluidCouplingData as FCDataForFB,
    fluidCouplingSelection as FCSelectionForFB,
} from '../../../lib/data/fluidCoupling-data-mmm-fb';
import {
    fluidCouplingData as FCDataForFD,
    fluidCouplingSelection as FCSelectionForFD,
} from '../../../lib/data/fluidCoupling-data-mmm-fd';
import { brakeData, selectBrake } from '../../../lib/data/brake-data';
import { holdbackData, selectBackstop } from '../../../lib/data/holdback-data';
import SpeedReducerTriple from './SpeedReducerTriple';

import { MultiInput, MultiOutput, MultiSelect } from '../common/MultiInput';

const DriveComponentTriple = ({
    drives,
    resistance,
    pulleys,
    fluidCouplings,
    gearCouplings,
    reducers,
    brakes,
    backstops,
}) => {
    const dispatch = useDispatch();

    // const [firstReducer, setFirstReducers] = useState(reducers?.[0] || {});
    const [firstFluidCoupling, setFirstFluidCoupling] = useState(fluidCouplings?.[0] || {});
    const [firstGearCoupling, setFirstGearCoupling] = useState(gearCouplings?.[0] || {});
    const [firstBrake, setFirstBrake] = useState(brakes?.[0] || {});
    const [firstBackstop, setFirstBackstop] = useState(backstops?.[0] || {});

    // const [secondReducer, setSecondReducers] = useState(reducers?.[1] || {});
    const [secondFluidCoupling, setSecondFluidCoupling] = useState(fluidCouplings?.[1] || {});
    const [secondGearCoupling, setSecondGearCoupling] = useState(gearCouplings?.[1] || {});
    const [secondBrake, setSecondBrake] = useState(brakes?.[1] || {});
    const [secondBackstop, setSecondBackstop] = useState(backstops?.[1] || {});

    // const [thirdReducer, setThirdReducers] = useState(reducers?.[2] || {});
    const [thirdFluidCoupling, setThirdFluidCoupling] = useState(fluidCouplings?.[2] || {});
    const [thirdGearCoupling, setThirdGearCoupling] = useState(gearCouplings?.[2] || {});
    const [thirdBrake, setThirdBrake] = useState(brakes?.[2] || {});
    const [thirdBackstop, setThirdBackstop] = useState(backstops?.[2] || {});

    /* Fluid Coupling */
    const handleFluidCouplingTypeSelection = (e) => {
        const { name, value } = e.target;
        const [category, key] = name.split('_');

        if (category === '1st') {
            setFirstFluidCoupling((prev) => ({
                ...prev,
                type: value,
            }));
        } else if (category === '2nd') {
            setSecondFluidCoupling((prev) => ({
                ...prev,
                type: value,
            }));
        } else if (category === '3rd') {
            setThirdFluidCoupling((prev) => ({
                ...prev,
                type: value,
            }));
        }
    };
    /* 1st Fluid Coupling - Selection */
    useEffect(() => {
        const motorRPM = Number(drives?.[0].motorRPM);
        const selectedMotor = Number(drives?.[0].selectedMotor);

        let fluidCouplingSelection;
        let fluidCouplingData;

        if (firstFluidCoupling.type === 'FB') {
            fluidCouplingSelection = FCSelectionForFB;
            fluidCouplingData = FCDataForFB;
        } else {
            fluidCouplingSelection = FCSelectionForFD;
            fluidCouplingData = FCDataForFD;
        }

        const index = motorRPM === 1800 ? 0 : motorRPM === 1200 ? 1 : motorRPM === 1500 ? 2 : 3;
        const objFound = fluidCouplingSelection.find((obj) => obj.motorRanking === selectedMotor);
        if (!objFound) {
            // alert('해당하는 모델이 없습니다.');
            return;
        }
        const selectedFluidCoupling = objFound.models[index];
        const obj = fluidCouplingData.find((obj) => obj.model === selectedFluidCoupling);
        if (!obj) {
            // alert('해당하는 모델이 없습니다.');
            return;
        }

        setFirstFluidCoupling((prev) => ({
            ...prev,
            selectedFluidCoupling,
            inertia: obj.inertia,
            weight: obj.weight,
        }));
    }, [drives, firstFluidCoupling.type]);

    /* 2nd Fluid Coupling - Selection */
    useEffect(() => {
        const motorRPM = Number(drives?.[1].motorRPM);
        const selectedMotor = Number(drives?.[1].selectedMotor);

        let fluidCouplingSelection;
        let fluidCouplingData;

        if (secondFluidCoupling.type === 'FB') {
            fluidCouplingSelection = FCSelectionForFB;
            fluidCouplingData = FCDataForFB;
        } else {
            fluidCouplingSelection = FCSelectionForFD;
            fluidCouplingData = FCDataForFD;
        }

        const index = motorRPM === 1800 ? 0 : motorRPM === 1200 ? 1 : motorRPM === 1500 ? 2 : 3;
        const objFound = fluidCouplingSelection.find((obj) => obj.motorRanking === selectedMotor);
        if (!objFound) {
            // alert('해당하는 모델이 없습니다.');
            return;
        }
        const selectedFluidCoupling = objFound.models[index];

        const obj = fluidCouplingData.find((obj) => obj.model === selectedFluidCoupling);
        if (!obj) {
            // alert('해당하는 모델이 없습니다.');
            return;
        }

        setSecondFluidCoupling((prev) => ({
            ...prev,
            selectedFluidCoupling,
            inertia: obj.inertia,
            weight: obj.weight,
        }));
    }, [drives, secondFluidCoupling.type]);

    /* 3rd Fluid Coupling - Selection */
    useEffect(() => {
        const motorRPM = Number(drives?.[1].motorRPM);
        const selectedMotor = Number(drives?.[1].selectedMotor);

        let fluidCouplingSelection;
        let fluidCouplingData;

        if (thirdFluidCoupling.type === 'FB') {
            fluidCouplingSelection = FCSelectionForFB;
            fluidCouplingData = FCDataForFB;
        } else {
            fluidCouplingSelection = FCSelectionForFD;
            fluidCouplingData = FCDataForFD;
        }

        const index = motorRPM === 1800 ? 0 : motorRPM === 1200 ? 1 : motorRPM === 1500 ? 2 : 3;
        const objFound = fluidCouplingSelection.find((obj) => obj.motorRanking === selectedMotor);
        if (!objFound) {
            // alert('해당하는 모델이 없습니다.');
            return;
        }
        const selectedFluidCoupling = objFound.models[index];

        const obj = fluidCouplingData.find((obj) => obj.model === selectedFluidCoupling);
        if (!obj) {
            // alert('해당하는 모델이 없습니다.');
            return;
        }

        setThirdFluidCoupling((prev) => ({
            ...prev,
            selectedFluidCoupling,
            inertia: obj.inertia,
            weight: obj.weight,
        }));
    }, [drives, thirdFluidCoupling.type]);

    /* Gear Coupling */
    const gearCouplingSelection = gearCouplingData.map((coupling) => {
        return {
            text: coupling.model,
            value: coupling.allowableTorque,
        };
    });

    const handleGearCouplingChange = (e) => {
        const { name, value } = e.target;
        const [category, key] = name.split('_');

        if (category === '1st') {
            setFirstGearCoupling((prev) => ({
                ...prev,
                [key]: value,
                // allowableTorque: value,
            }));
        } else if (category === '2nd') {
            setSecondGearCoupling((prev) => ({
                ...prev,
                [key]: value,
                // allowableTorque: value,
            }));
        } else if (category === '3rd') {
            setThirdGearCoupling((prev) => ({
                ...prev,
                [key]: value,
            }));
        }
    };

    const handleGearCouplingSelection = (e) => {
        const { name, value } = e.target;
        const [category, key] = name.split('_');

        const selected = selectGearCoupling(value);
        if (!selected) return;

        if (category === '1st') {
            setFirstGearCoupling((prev) => ({
                ...prev,
                model: selected.model,
                allowableTorque: selected.allowableTorque,
                maxRPM: selected.maxRPM,
                weight: selected.weight,
                inertia: selected.inertia,
            }));
        } else if (category === '2nd') {
            setSecondGearCoupling((prev) => ({
                ...prev,
                model: selected.model,
                allowableTorque: selected.allowableTorque,
                maxRPM: selected.maxRPM,
                weight: selected.weight,
                inertia: selected.inertia,
            }));
        } else if (category === '3rd') {
            setThirdGearCoupling((prev) => ({
                ...prev,
                model: selected.model,
                allowableTorque: selected.allowableTorque,
                maxRPM: selected.maxRPM,
                weight: selected.weight,
                inertia: selected.inertia,
            }));
        }
    };

    /* 1st Gear Coupling - Actual Torque */
    useEffect(() => {
        if (!drives || !pulleys) return;

        const T1 = Number(drives?.[0].tightSideTension?.load);
        const T2 = Number(drives?.[0].slackSideTension?.load);
        const D = Number(pulleys?.[0].diaWithLagging) / 1000; // 단위환산 mm -> m

        const actualTorqueApplied = Math.ceil(((T1 - T2) * D) / 2); // N-m

        setFirstGearCoupling((prev) => ({
            ...prev,
            actualTorqueApplied,
        }));
    }, [drives?.[0], pulleys?.[0].diaWithLagging]);

    /* 1st Gear Coupling - Required Torque, Selection */
    useEffect(() => {
        if (!firstGearCoupling.safetyFactor) return;
        const requiredTorque = firstGearCoupling.safetyFactor * firstGearCoupling.actualTorqueApplied;

        const safetyMargin = Number(firstGearCoupling.allowableTorque) / requiredTorque;
        const isSafe = safetyMargin < 1 ? false : true;

        setFirstGearCoupling((prev) => ({
            ...prev,
            requiredTorque: Math.ceil(requiredTorque),
            safetyMargin: Math.ceil(safetyMargin * 100) / 100,
            isSafe: !!isSafe,
        }));
    }, [firstGearCoupling.actualTorqueApplied, firstGearCoupling.allowableTorque, firstGearCoupling.safetyFactor]);

    /* 2nd Gear Coupling - Actual Torque */
    useEffect(() => {
        if (!drives || !pulleys) return;

        const T1 = Number(drives?.[1].tightSideTension?.load);
        const T2 = Number(drives?.[1].slackSideTension?.load);
        const D = Number(pulleys?.[1].diaWithLagging) / 1000; // 단위환산 mm -> m
        const actualTorqueApplied = Math.ceil(((T1 - T2) * D) / 2); // N-m

        setSecondGearCoupling((prev) => ({
            ...prev,
            actualTorqueApplied,
        }));
    }, [drives?.[1], pulleys?.[1].diaWithLagging]);

    /* 2nd Gear Coupling - Required Torque, Selection */
    useEffect(() => {
        if (!secondGearCoupling.safetyFactor) return;
        const requiredTorque = secondGearCoupling.safetyFactor * secondGearCoupling.actualTorqueApplied;

        const safetyMargin = Number(secondGearCoupling.allowableTorque) / requiredTorque;
        const isSafe = safetyMargin < 1 ? false : true;

        setSecondGearCoupling((prev) => ({
            ...prev,
            requiredTorque: Math.ceil(requiredTorque),
            safetyMargin: Math.ceil(safetyMargin * 100) / 100,
            isSafe: !!isSafe,
        }));
    }, [secondGearCoupling.actualTorqueApplied, secondGearCoupling.allowableTorque, secondGearCoupling.safetyFactor]);

    /* 3rd Gear Coupling - Actual Torque */
    useEffect(() => {
        if (!drives || !pulleys) return;

        const T1 = Number(drives?.[2].tightSideTension?.load);
        const T2 = Number(drives?.[2].slackSideTension?.load);
        const D = Number(pulleys?.[2].diaWithLagging) / 1000; // 단위환산 mm -> m
        const actualTorqueApplied = Math.ceil(((T1 - T2) * D) / 2); // N-m

        setThirdGearCoupling((prev) => ({
            ...prev,
            actualTorqueApplied,
        }));
    }, [drives?.[2], pulleys?.[2].diaWithLagging]);

    /* 3rd Gear Coupling - Required Torque, Selection */
    useEffect(() => {
        if (!thirdGearCoupling.safetyFactor) return;
        const requiredTorque = thirdGearCoupling.safetyFactor * thirdGearCoupling.actualTorqueApplied;

        const safetyMargin = Number(thirdGearCoupling.allowableTorque) / requiredTorque;
        const isSafe = safetyMargin < 1 ? false : true;

        setThirdGearCoupling((prev) => ({
            ...prev,
            requiredTorque: Math.ceil(requiredTorque),
            safetyMargin: Math.ceil(safetyMargin * 100) / 100,
            isSafe: !!isSafe,
        }));
    }, [thirdGearCoupling.actualTorqueApplied, thirdGearCoupling.allowableTorque, thirdGearCoupling.safetyFactor]);

    /* Brake */
    const brakeRanking = brakeData.map((brake) => {
        return {
            text: brake.model,
            value: brake.torque,
        };
    });

    const handleBrakeChange = (e) => {
        const { name, value } = e.target;
        const [category, key] = name.split('_');

        if (category === '1st') {
            setFirstBrake((prev) => ({
                ...prev,
                [key]: value,
            }));
        } else if (category === '2nd') {
            setSecondBrake((prev) => ({
                ...prev,
                [key]: value,
            }));
        } else if (category === '3rd') {
            setThirdBrake((prev) => ({
                ...prev,
                [key]: value,
            }));
        }
    };

    const handleBrakeSelection = (e) => {
        const { name, value } = e.target;
        const [category, key] = name.split('_');

        const selected = selectBrake(value);
        if (!selected) return;

        if (category === '1st') {
            setFirstBrake((prev) => ({
                ...prev,
                model: selected.model,
                torque: selected.torque,
                weight: selected.weight,
                inertia: selected.inertia,
            }));
        } else if (category === '2nd') {
            setSecondBrake((prev) => ({
                ...prev,
                model: selected.model,
                torque: selected.torque,
                weight: selected.weight,
                inertia: selected.inertia,
            }));
        } else if (category === '3rd') {
            setThirdBrake((prev) => ({
                ...prev,
                model: selected.model,
                torque: selected.torque,
                weight: selected.weight,
                inertia: selected.inertia,
            }));
        }
    };

    /* 1st Brake - Selection */
    useEffect(() => {
        if (!drives?.[0].ratedMotorTorque) return;

        const motorTorque = Number(drives?.[0].ratedMotorTorque); // kg-m
        const requiredTorque = 1.0 * motorTorque; // kg-m

        const safetyMargin = Number(firstBrake.torque) / requiredTorque;
        const isSafe = safetyMargin < 1 ? false : true;

        setFirstBrake((prev) => ({
            ...prev,
            requiredTorque,
            safetyMargin: Math.ceil(safetyMargin * 100) / 100,
            isSafe: !!isSafe,
        }));
    }, [drives, firstBrake.torque]);

    /* 2nd Brake - Selection */
    useEffect(() => {
        if (!drives?.[1].ratedMotorTorque) return;

        const motorTorque = Number(drives?.[1].ratedMotorTorque); // kg-m
        const requiredTorque = 1.0 * motorTorque; // kg-m

        const safetyMargin = Number(secondBrake.torque) / requiredTorque;
        const isSafe = safetyMargin < 1 ? false : true;

        setSecondBrake((prev) => ({
            ...prev,
            requiredTorque,
            safetyMargin: Math.ceil(safetyMargin * 100) / 100,
            isSafe: !!isSafe,
        }));
    }, [drives, secondBrake.torque]);

    /* 3rd Brake - Selection */
    useEffect(() => {
        if (!drives?.[2].ratedMotorTorque) return;

        const motorTorque = Number(drives?.[2].ratedMotorTorque); // kg-m
        const requiredTorque = 1.0 * motorTorque; // kg-m

        const safetyMargin = Number(thirdBrake.torque) / requiredTorque;
        const isSafe = safetyMargin < 1 ? false : true;

        setThirdBrake((prev) => ({
            ...prev,
            requiredTorque,
            safetyMargin: Math.ceil(safetyMargin * 100) / 100,
            isSafe: !!isSafe,
        }));
    }, [drives, thirdBrake.torque]);

    /* Backstop */
    const backstopRanking = holdbackData.map((holdback) => {
        return {
            text: holdback.model,
            value: holdback.torque,
        };
    });

    const handleBackstopSelection = (e) => {
        const { name, value } = e.target;
        const [category, key] = name.split('_');

        const selected = selectBackstop(value);
        if (!selected) return;

        if (category === '1st') {
            setFirstBackstop((prev) => ({
                ...prev,
                model: selected.model,
                torque: selected.torque,
                weight: selected.weight,
            }));
        } else if (category === '2nd') {
            setSecondBackstop((prev) => ({
                ...prev,
                model: selected.model,
                torque: selected.torque,
                weight: selected.weight,
            }));
        } else if (category === '3rd') {
            setThirdBackstop((prev) => ({
                ...prev,
                model: selected.model,
                torque: selected.torque,
                weight: selected.weight,
            }));
        }
    };

    /* 1st Backstop - Reverse Torque 계산 */
    useEffect(() => {
        const reverseForce = Number(resistance?.reverse?.load);
        const distribution = Number(drives?.[0].distribution);
        if (reverseForce < 0) {
            return;
        }
        const firstDrivePulley = pulleys?.find((pulley) => pulley.application === '1st Drive');
        if (!firstDrivePulley) {
            return;
        }
        const pulleyDia = Number(firstDrivePulley.diaWithLagging);
        // const reverseTorque = Math.ceil((((1.25 * pulleyDia) / 2000) * reverseForce * distribution) / 100);
        const reverseTorque = Math.ceil((pulleyDia/2000) * reverseForce * (distribution/100));
        const safetyMargin = Number(firstBackstop.torque) / reverseTorque;
        const isSafe = safetyMargin < 1 ? false : true;

        setFirstBackstop((prev) => ({
            ...prev,
            reverseTorque,
            safetyMargin: Math.ceil(safetyMargin * 100) / 100,
            isSafe: !!isSafe,
        }));
    }, [drives, firstBackstop.torque, pulleys, resistance?.reverse]);

    /* 2nd Backstop - Reverse Torque 계산 */
    useEffect(() => {
        const reverseForce = Number(resistance?.reverse?.load);
        const distribution = Number(drives?.[1].distribution);
        if (reverseForce < 0) {
            return;
        }
        const secondDrivePulley = pulleys?.find((pulley) => pulley.application === '2nd Drive');
        if (!secondDrivePulley) {
            return;
        }
        const pulleyDia = Number(secondDrivePulley.diaWithLagging);
        // const reverseTorque = Math.ceil((((1.25 * pulleyDia) / 2000) * reverseForce * distribution) / 100);
        const reverseTorque = Math.ceil((pulleyDia/2000) * reverseForce * (distribution/100));
        const safetyMargin = Number(secondBackstop.torque) / reverseTorque;
        const isSafe = safetyMargin < 1 ? false : true;

        setSecondBackstop((prev) => ({
            ...prev,
            reverseTorque,
            safetyMargin: Math.ceil(safetyMargin * 100) / 100,
            isSafe: !!isSafe,
        }));
    }, [drives, pulleys, resistance?.reverse, secondBackstop.torque]);

    /* 3rd Backstop - Reverse Torque 계산 */
    useEffect(() => {
        const reverseForce = Number(resistance?.reverse?.load);
        const distribution = Number(drives?.[2].distribution);
        if (reverseForce < 0) {
            return;
        }
        const thirdDrivePulley = pulleys?.find((pulley) => pulley.application === '3rd Drive');
        if (!thirdDrivePulley) {
            return;
        }
        const pulleyDia = Number(thirdDrivePulley.diaWithLagging);
        // const reverseTorque = Math.ceil((((1.25 * pulleyDia) / 2000) * reverseForce * distribution) / 100);
        const reverseTorque = Math.ceil((pulleyDia/2000) * reverseForce * (distribution/100));
        const safetyMargin = Number(thirdBackstop.torque) / reverseTorque;
        const isSafe = safetyMargin < 1 ? false : true;

        setThirdBackstop((prev) => ({
            ...prev,
            reverseTorque,
            safetyMargin: Math.ceil(safetyMargin * 100) / 100,
            isSafe: !!isSafe,
        }));
    }, [drives, pulleys, resistance?.reverse, thirdBackstop.torque]);

    /* 리덕스에 쓰기 */
    useEffect(() => {
        dispatch(
            changeBody({
                key: 'fluidCouplings',
                value: [firstFluidCoupling, secondFluidCoupling, thirdFluidCoupling],
            }),
        );
    }, [dispatch, firstFluidCoupling, secondFluidCoupling, thirdFluidCoupling]);

    useEffect(() => {
        dispatch(
            changeBody({
                key: 'gearCouplings',
                value: [firstGearCoupling, secondGearCoupling, thirdGearCoupling],
            }),
        );
    }, [dispatch, firstGearCoupling, secondGearCoupling, thirdGearCoupling]);

    // useEffect(() => {
    //     dispatch(
    //         changeBody({
    //             key: 'reducers',
    //             value: [firstReducer, secondReducer, thirdReducer],
    //         }),
    //     );
    // }, [dispatch, firstReducer, secondReducer, thirdReducer]);

    useEffect(() => {
        dispatch(
            changeBody({
                key: 'brakes',
                value: [firstBrake, secondBrake, thirdBrake],
            }),
        );
    }, [dispatch, firstBrake, secondBrake, thirdBrake]);

    useEffect(() => {
        dispatch(
            changeBody({
                key: 'backstops',
                value: [firstBackstop, secondBackstop, thirdBackstop],
            }),
        );
    }, [dispatch, firstBackstop, secondBackstop, thirdBackstop]);

    return (
        <>
            <SpeedReducerTriple reducers={reducers} />
            {/* Fluid Coupling */}
            <SubTitle>Fluid Coupling(s):</SubTitle>
            <MultiOutput
                label="Installed Motor"
                variable="-"
                variableName="-"
                unit="kW"
                values={[drives?.[0].selectedMotor, drives?.[1].selectedMotor, drives?.[2].selectedMotor]}
            />
            <MultiOutput
                label="Motor RPM"
                variable="RPM"
                variableName="-"
                unit="1/min"
                values={[drives?.[0].motorRPM, drives?.[1].motorRPM, drives?.[2].motorRPM]}
            />
            <MultiSelect
                label="Fluid Coupling Type"
                variable="-"
                variableName="type"
                unit="-"
                values={[firstFluidCoupling.type, secondFluidCoupling.type, thirdFluidCoupling.type]}
                options={[
                    { text: 'FB形式', value: 'FB' },
                    { text: 'FD形式', value: 'FD' },
                ]}
                onChange={handleFluidCouplingTypeSelection}
            />
            <MultiOutput
                label="Selected Model"
                variable="-"
                variableName="-"
                unit="-"
                values={[
                    firstFluidCoupling.selectedFluidCoupling,
                    secondFluidCoupling.selectedFluidCoupling,
                    thirdFluidCoupling.selectedFluidCoupling,
                ]}
            />
            {/* <MultiSelect
                label="Model No."
                variable="-"
                variableName="model"
                unit="-"
                value={firstFluidCoupling.model}
                options={fluidCouplingSelection}
                onChange={null}
                isRequired
            /> */}

            {/* Gear Coupling */}
            <SubTitle>Gear Coupling(s):</SubTitle>
            <MultiOutput
                label="Actual Torque applied at Pulley Shaft"
                variable="-"
                variableName="-"
                unit="N-m"
                values={[
                    firstGearCoupling.actualTorqueApplied,
                    secondGearCoupling.actualTorqueApplied,
                    thirdGearCoupling.actualTorqueApplied,
                ]}
            />
            <MultiInput
                label="Safety Factor of Gear Coupling"
                variable="-"
                unit="-"
                variableName="safetyFactor"
                values={[
                    firstGearCoupling.safetyFactor,
                    secondGearCoupling.safetyFactor,
                    thirdGearCoupling.safetyFactor,
                ]}
                referenceValues={[1.5, 1.5, 1.5]}
                onChange={handleGearCouplingChange}
            />
            <MultiOutput
                label="Required Torque for Gear Coupling"
                variable="-"
                unit="N-m"
                variableName="requiredTorque"
                values={[
                    firstGearCoupling.requiredTorque,
                    secondGearCoupling.requiredTorque,
                    thirdGearCoupling.requiredTorque,
                ]}
            />
            <MultiSelect
                label="Model No."
                variable="-"
                variableName="allowableTorque"
                unit="-"
                values={[
                    firstGearCoupling.allowableTorque,
                    secondGearCoupling.allowableTorque,
                    thirdGearCoupling.allowableTorque,
                ]}
                options={gearCouplingSelection}
                onChange={handleGearCouplingSelection}
                isRequired
            />
            <MultiOutput
                label="Rated Torque of Gear Coupling Selected"
                variable="-"
                unit="N-m"
                variableName="allowableTorque"
                values={[
                    firstGearCoupling.allowableTorque,
                    secondGearCoupling.allowableTorque,
                    thirdGearCoupling.allowableTorque,
                ]}
            />
            <MultiOutput
                label="Safety Margin"
                variable="-"
                unit="-"
                variableName="-"
                values={[
                    firstGearCoupling.safetyMargin,
                    secondGearCoupling.safetyMargin,
                    thirdGearCoupling.safetyMargin,
                ]}
                isSafeArray={[firstGearCoupling.isSafe, secondGearCoupling.isSafe, thirdGearCoupling.isSafe]}
            />

            {/* Brake */}
            <SubTitle>Brake(s):</SubTitle>
            <MultiInput
                label="Braking Torque Required"
                variable="-"
                unit="N-m"
                variableName="requiredTorque"
                values={[firstBrake.requiredTorque, secondBrake.requiredTorque, thirdBrake.requiredTorque]}
                referenceValues={[
                    drives?.[0].ratedMotorTorque,
                    drives?.[1].ratedMotorTorque,
                    drives?.[2].ratedMotorTorque,
                ]}
                onChange={handleBrakeChange}
            />
            <MultiSelect
                label="Model No."
                variable="-"
                variableName="model"
                unit="-"
                values={[firstBrake.torque, secondBrake.torque, thirdBrake.torque]}
                options={brakeRanking}
                onChange={handleBrakeSelection}
                isRequired
            />
            <MultiOutput
                label="Rated Torque of Brake Selected"
                variable="-"
                unit="N-m"
                variableName="brakeTorque"
                values={[firstBrake.torque, secondBrake.torque, thirdBrake.torque]}
            />
            <MultiOutput
                label="Safety Margin"
                variable="-"
                unit="-"
                variableName="-"
                values={[firstBrake.safetyMargin, secondBrake.safetyMargin, thirdBrake.safetyMargin]}
                isSafeArray={[firstBrake.isSafe, secondBrake.isSafe, thirdBrake.isSafe]}
            />

            {/* Back-stop */}
            <SubTitle>Back-stop(s):</SubTitle>
            <MultiOutput
                label="Reverse Torque"
                variable="-"
                variableName="reverseTorque"
                unit="N-m"
                values={[firstBackstop.reverseTorque, secondBackstop.reverseTorque, thirdBackstop.reverseTorque]}
            />
            <MultiSelect
                label="Model No."
                variable="-"
                variableName="model"
                unit="-"
                values={[firstBackstop.torque, secondBackstop.torque, thirdBackstop.torque]}
                options={backstopRanking}
                onChange={handleBackstopSelection}
            />
            <MultiOutput
                label="Rated Torque of Backtop Selected"
                variable="-"
                unit="N-m"
                variableName="backstopTorque"
                values={[firstBackstop.torque, secondBackstop.torque, thirdBackstop.torque]}
            />
            <MultiOutput
                label="Safety Margin"
                variable="-"
                unit="-"
                variableName="-"
                values={[firstBackstop.safetyMargin, secondBackstop.safetyMargin, thirdBackstop.safetyMargin]}
                isSafeArray={[firstBackstop.isSafe, secondBackstop.isSafe, thirdBackstop.isSafe]}
            />
        </>
    );
};

export default DriveComponentTriple;

/* =================   Styles   ================== */
export const Input = styled.input`
    width: 100%;
    box-sizing: border-box;
    border: none;
    outline: none;
    background-color: ${palette.cyan[0]};
    text-align: right;
    // width: 80px;
    padding: 0.25rem 0;
    padding-right: 0.5rem;
    font-size: 0.95rem;

    &::placeholder {
        color: ${palette.lime[5]};
        font-style: italic;
    }

    ${(props) =>
        props.isRequired &&
        css`
            background-color: ${palette.yachtBlue};
            color: white;
        `}
`;

export const RowInput = ({
    label,
    variable,
    unit,
    variableName,
    values,
    min = '0',
    referenceValues,
    handleChange,
    isRequired,
}) => {
    return (
        <tr className="tr-hover-effect">
            <td style={{ width: '100%', padding: '0.5rem 1rem' }}>
                <span
                    style={{
                        display: 'block',
                        width: '100%',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                    }}
                >
                    {label}
                </span>
            </td>
            <td style={{ minWidth: '120px', fontSize: '0.9rem', color: `${palette.gray[6]}`, textAlign: 'right' }}>
                {variable}
            </td>
            <td
                style={{
                    minWidth: '120px',
                    textAlign: 'right',
                    paddingRight: '0.5rem',
                    // fontSize: isSub ? '0.85rem' : '0.95rem',
                    // color: isSub ? `${palette.gray[6]}` : null,
                }}
            >
                <Input
                    name={`1st_${variableName}`}
                    value={values[0]}
                    placeholder={referenceValues && referenceValues[0]}
                    // onChange={handleChange}
                    onChange={(e) => {
                        const newValue = e.target.value;
                        // 숫자가 아니거나 'min'보다 작으면 실행하지 않음
                        if (newValue === '' || Number(newValue) >= Number(min)) {
                            handleChange(e);
                        }
                    }}
                    isRequired={isRequired}
                />
            </td>
            <td
                style={{
                    minWidth: '120px',
                    textAlign: 'right',
                    paddingRight: '0.5rem',
                    // fontSize: isSub ? '0.85rem' : '0.95rem',
                    // color: isSub ? `${palette.gray[6]}` : null,
                }}
            >
                <Input
                    name={`2nd_${variableName}`}
                    value={values[1]}
                    placeholder={referenceValues && referenceValues[1]}
                    // onChange={handleChange}
                    onChange={(e) => {
                        const newValue = e.target.value;
                        // 숫자가 아니거나 'min'보다 작으면 실행하지 않음
                        if (newValue === '' || Number(newValue) >= Number(min)) {
                            handleChange(e);
                        }
                    }}
                    isRequired={isRequired}
                />
            </td>
            <td
                style={{
                    minWidth: '120px',
                    textAlign: 'right',
                    paddingRight: '0.5rem',
                    // fontSize: isSub ? '0.85rem' : '0.95rem',
                    // color: isSub ? `${palette.gray[6]}` : null,
                }}
            >
                <Input
                    name={`3rd_${variableName}`}
                    value={values[2]}
                    placeholder={referenceValues && referenceValues[2]}
                    // onChange={handleChange}
                    onChange={(e) => {
                        const newValue = e.target.value;
                        // 숫자가 아니거나 'min'보다 작으면 실행하지 않음
                        if (newValue === '' || Number(newValue) >= Number(min)) {
                            handleChange(e);
                        }
                    }}
                    isRequired={isRequired}
                />
            </td>
            <td style={unitStyle}>{unit}</td>
        </tr>
    );
};

export const RowOutput = ({ label, variable, unit, values, isSub, isWarning }) => {
    return (
        <tr className="tr-hover-effect">
            <td style={{ width: '100%', padding: '0.5rem 1rem' }}>
                <span
                    style={{
                        display: 'block',
                        width: '100%',
                        paddingLeft: isSub ? '1rem' : 0,
                        color: isSub ? `${palette.gray[6]}` : null,
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                    }}
                >
                    {label}
                </span>
            </td>
            <td style={variableStyle}>{variable}</td>
            <td
                style={{
                    minWidth: '120px',
                    fontSize: isSub ? '0.85rem' : '0.95rem',
                    textAlign: 'right',
                    paddingRight: '1rem',
                    color: isSub ? `${palette.gray[6]}` : isWarning?.[0] ? 'red' : null,
                }}
            >
                {formatDisplayValue(values[0])}
            </td>
            <td
                style={{
                    minWidth: '120px',
                    fontSize: isSub ? '0.85rem' : '0.95rem',
                    textAlign: 'right',
                    paddingRight: '1rem',
                    color: isSub ? `${palette.gray[6]}` : isWarning?.[1] ? 'red' : null,
                }}
            >
                {formatDisplayValue(values[1])}
            </td>
            <td
                style={{
                    minWidth: '120px',
                    fontSize: isSub ? '0.85rem' : '0.95rem',
                    textAlign: 'right',
                    paddingRight: '1rem',
                    color: isSub ? `${palette.gray[6]}` : isWarning?.[2] ? 'red' : null,
                }}
            >
                {formatDisplayValue(values[2])}
            </td>
            <td style={unitStyle}>{unit}</td>
        </tr>
    );
};

/* =================   Styles   ================== */
const Select = styled.select`
    width: 100%;
    border: none;
    outline: none;
    padding: 0.25rem 0;
    text-align: center;
    background-color: ${palette.cyan[0]};
    ${(props) =>
        props.isRequired &&
        css`
            background-color: ${palette.yachtBlue};
            color: white;
        `}
`;

export const RowSelect = ({ label, variable, unit, variableName, values, options, handleChange, isRequired }) => {
    return (
        <tr className="tr-hover-effect">
            <td style={{ width: '100%', minWidth: '500px', padding: '0.5rem 1rem' }}>
                <span
                    style={{
                        display: 'block',
                        width: '100%',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                    }}
                >
                    {label}
                </span>
            </td>
            <td style={{ textAlign: 'right' }}>-</td>
            <td style={{ width: '100px' }}>
                <Select name={`1st_${variableName}`} value={values[0]} onChange={handleChange} isRequired={isRequired}>
                    <option value="" selected disabled>
                        Select...
                    </option>
                    {options.map((item) => (
                        <option value={item.value}>{`${item.text} / ${item.value}N-m`}</option>
                    ))}
                </Select>
            </td>
            <td style={{ width: '100px' }}>
                <Select name={`2nd_${variableName}`} value={values[1]} onChange={handleChange} isRequired={isRequired}>
                    <option value="" selected disabled>
                        Select...
                    </option>
                    {options.map((item) => (
                        <option value={item.value}>{`${item.text} / ${item.value}N-m`}</option>
                    ))}
                </Select>
            </td>
            <td style={{ width: '100px' }}>
                <Select name={`3rd_${variableName}`} value={values[2]} onChange={handleChange} isRequired={isRequired}>
                    <option value="" selected disabled>
                        Select...
                    </option>
                    {options.map((item) => (
                        <option value={item.value}>{`${item.text} / ${item.value}N-m`}</option>
                    ))}
                </Select>
            </td>
            <td>-</td>
        </tr>
    );
};

const variableStyle = {
    minWidth: '100px',
    fontSize: '0.9rem',
    textAlign: 'right',
    color: `${palette.gray[6]}`,
};

const unitStyle = {
    minWidth: '60px',
    fontSize: '0.9rem',
    color: `${palette.gray[6]}`,
};

const SubTitle = styled.p`
    margin-left: 1rem;
    font-weight: 800;
`;
